var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTori(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3423_33392)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_di_3423_33392)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.59594 20.1922C8.51479 20.1188 8.46397 20.0164 8.45383 19.9059L7.64697 11.1099H10.5185V20.9643C10.5185 21.3401 10.0858 21.5401 9.81084 21.2914L8.59594 20.1922Z",
    fill: "url(#paint0_linear_3423_33392)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5184 10.9354V9.70745L7.49365 9.4397L7.63086 10.9354H10.5184Z",
    fill: "url(#paint1_linear_3423_33392)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5181 9.53216L7.4772 9.26292L7.00191 4.08145C6.97842 3.82545 7.17495 3.60425 7.42587 3.60425H10.0923C10.3274 3.60425 10.5181 3.79962 10.5181 4.04061V9.53216Z",
    fill: "url(#paint2_linear_3423_33392)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1304 10.9353H18.3192C18.4369 10.9353 18.5322 10.8376 18.5322 10.7171V9.43034C18.5322 9.30152 18.4237 9.20072 18.2985 9.2132L16.266 9.41664L16.1304 10.9353Z",
    fill: "url(#paint3_linear_3423_33392)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0933 9.43384L13.0645 9.73685V10.9352H15.9593L16.0933 9.43384Z",
    fill: "url(#paint4_linear_3423_33392)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8944 9.754V10.9352H4.82913C4.71154 10.9352 4.61621 10.8376 4.61621 10.7171V9.42742C4.61621 9.29966 4.72298 9.19921 4.84727 9.21003L12.0152 9.83831C12.0282 9.83944 12.0411 9.83935 12.0541 9.83804L12.8944 9.754Z",
    fill: "url(#paint5_linear_3423_33392)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7935 21.2617C13.5261 21.5395 13.0645 21.3454 13.0645 20.9552V7.41821H16.2774L15.1597 19.7021C15.1505 19.8023 15.1079 19.8962 15.0389 19.968L13.7935 21.2617Z",
    fill: "url(#paint6_linear_3423_33392)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2933 7.2438H13.0645V5.36242L16.4843 5.1438L16.2933 7.2438Z",
    fill: "url(#paint7_linear_3423_33392)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0645 4.04086V5.1875L16.5003 4.96786L16.5811 4.08137C16.6043 3.82548 16.4078 3.60449 16.157 3.60449H13.4903C13.2551 3.60449 13.0645 3.79986 13.0645 4.04086Z",
    fill: "url(#paint8_linear_3423_33392)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5182 7.24372V5.36781L7.10254 5.19556L7.28942 7.24372H10.5182Z",
    fill: "url(#paint9_linear_3423_33392)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6885 7.24377H19.2988C19.3929 7.24377 19.4692 7.16563 19.4692 7.06923V5.13012C19.4692 5.02936 19.3861 4.94954 19.288 4.95592L11.8936 5.43723L10.6885 5.37645V7.24377Z",
    fill: "url(#paint10_linear_3423_33392)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.91665 5.18618L7.12067 7.24372H3.67082C3.57675 7.24372 3.50049 7.16558 3.50049 7.06918V5.19725C3.50049 5.09749 3.58195 5.01802 3.67919 5.02292L6.91665 5.18618Z",
    fill: "url(#paint11_linear_3423_33392)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_di_3423_33392",
    x: 3.50049,
    y: 3.60425,
    width: 16.1817,
    height: 18.01,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.170334,
    dy: 0.170334
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.0212917
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3423_33392"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3423_33392",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.0340667
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.0170334
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_3423_33392"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3423_33392",
    x1: 3.50075,
    y1: 12.5029,
    x2: 19.4695,
    y2: 12.5029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5433FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#20BDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A5FECB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3423_33392",
    x1: 3.50063,
    y1: 12.503,
    x2: 19.4694,
    y2: 12.503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5433FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#20BDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A5FECB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3423_33392",
    x1: 3.50038,
    y1: 12.5028,
    x2: 19.4691,
    y2: 12.5028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5433FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#20BDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A5FECB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3423_33392",
    x1: 3.50022,
    y1: 12.5029,
    x2: 19.469,
    y2: 12.5029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5433FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#20BDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A5FECB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3423_33392",
    x1: 3.50022,
    y1: 12.5029,
    x2: 19.469,
    y2: 12.5029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5433FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#20BDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A5FECB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3423_33392",
    x1: 3.50053,
    y1: 12.5029,
    x2: 19.4693,
    y2: 12.5029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5433FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#20BDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A5FECB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3423_33392",
    x1: 3.50022,
    y1: 12.5029,
    x2: 19.469,
    y2: 12.5029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5433FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#20BDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A5FECB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3423_33392",
    x1: 3.50022,
    y1: 12.5031,
    x2: 19.469,
    y2: 12.5031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5433FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#20BDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A5FECB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3423_33392",
    x1: 3.50022,
    y1: 12.503,
    x2: 19.469,
    y2: 12.503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5433FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#20BDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A5FECB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_3423_33392",
    x1: 3.50048,
    y1: 12.503,
    x2: 19.4692,
    y2: 12.503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5433FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#20BDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A5FECB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_3423_33392",
    x1: 3.5004,
    y1: 12.503,
    x2: 19.4692,
    y2: 12.503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5433FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#20BDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A5FECB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_3423_33392",
    x1: 3.50049,
    y1: 12.503,
    x2: 19.4693,
    y2: 12.503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5433FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#20BDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A5FECB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3423_33392"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTori);
export default __webpack_public_path__ + "static/media/tori.8016c835432585b7b2e7e6e99ac0eb5e.svg";
export { ForwardRef as ReactComponent };